import useAZZKUTopics from "hooks/AZZKU/useAZZKUTopics";
import useAZZKURelations from "hooks/AZZKU/useAZZKURelations";

import CheckboxGroup from "components/CheckboxGroup";
import ExpandableBox from "components/ExpandableBox";
import Options from "components/Options";
import Loader from "components/Loader";

function RelationsBox({ params, errors, onChange }) {

   const { d: relations_options } = useAZZKURelations( params.variable_id );

   return relations_options && relations_options?.length ? (
      <ExpandableBox heading={ <> Wybór relacji (opcjonalny) <br/> Relacja to porównanie dwóch wybranych wskaźników - obliczana jako ich iloraz. </>}>
         <Options
            name="relation_id"
            value={ params.relation_id || []}
            error={ errors.relation_id }
            options={ relations_options }
            onChange={ onChange }
         />
      </ExpandableBox>
   ) : null
}

export default function Step1({ params, errors, onChange }) {

   const { d: topics } = useAZZKUTopics();

   return topics ? (
      <>
         <p> Wybierz kategorię, a następnie wskaż dane, które chcesz przeanalizować na wykresach. </p>

         <ExpandableBox heading="Kategoria danych">

            <CheckboxGroup
               name="topics"
               value={ params.topics || []}
               style={{ gap: "10px 36px" }}
               item_style={{ flex: "unset" }}
               buttons={ topics || []}
               onChange={( n, v ) => onChange({
                  [ n ]: v,
                  variable_id: undefined
               })}
            />

            { params.topics && !!params.topics?.length &&
               params.topics.map(( topic_id ) => {

                  const topic = topics.find( t => t.value === topic_id );

                  return (
                     <ExpandableBox
                        key={ topic_id } 
                        heading={ topic.label }
                        extra_classes="inner"
                     >
                        <Options
                           name={ "variable_id_" + topic_id }
                           value={ params.variable_id }
                           options={ topic?.variables }
                           onChange={( n, v ) => onChange({
                              variable_id: v,
                              relation_id: undefined
                           })}
                        />
                     </ExpandableBox>
                  )
               })
            }

            {( errors.topics || errors.variable_id ) &&
               <div className="error">
                  { errors.topics || errors.variable_id } 
               </div>
            }
         </ExpandableBox>

         { params.variable_id && 
            <RelationsBox
               params={ params }
               errors={ errors }
               onChange={ onChange }
            />
         }
      </>
   ) : <Loader/>
}